/** Enum defining the media queue container metadata types. */
enum MediaQueueContainerType {
  /** A media type representing an audio book. */
  AUDIO_BOOK = 'audioBook',
}

export default MediaQueueContainerType
